import { useEffect } from "react";

const useBodyScroll = (active) => {
  useEffect(() => {
    if (typeof document !== "undefined") {
      const bodyElem = document.body;

      if (active) {
        bodyElem.classList.add("menu-open");
      }

      return () => {
        bodyElem.classList.remove("menu-open");
      };
    }
  }, [active]);
};

export default useBodyScroll;
